
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competitors",
      function () {
        return require("private-next-pages/competitors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competitors"])
      });
    }
  